import { render, staticRenderFns } from "./success-dialog.vue?vue&type=template&id=15134316&scoped=true&"
import script from "./success-dialog.vue?vue&type=script&lang=ts&"
export * from "./success-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./success-dialog.vue?vue&type=style&index=0&id=15134316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15134316",
  null
  
)

export default component.exports